import { CampaignForm } from "@/components/Views/B2BFinance/CampaignForms/CampaignForm";
import CampaignList from "@/components/Views/B2BFinance/CampaignList";


const B2bFinance = () => {
  return (
    <div>
      <CampaignForm />  
      <CampaignList />
    </div>
  );
};

export default B2bFinance;
